import decodeJwt from "@/helpers/decodeJwt"

export default () => {
  const jwtInfo = decodeJwt()
  if (jwtInfo) {
    return jwtInfo.type === 3 ? 'publisher' : 'retailer'
  }
}
